/* ============================================================
   vel-base.js — Velora runtime (framework-free)

   Portiert die Interaktionen aus den Quell-HTMLs (_source/) und
   haengt sie an echte Shopify-Daten:
     mobile Nav, Scroll-Reveal, Collection-Filter/Sort,
     Produktgalerie, Varianten-Picker, Mengen-Stepper,
     AJAX-Warenkorb (/cart/add.js, /cart.js) + Cart-Drawer,
     Related Products (Recommendations API).

   Alle Hooks sind guarded; init() laeuft erneut auf
   shopify:section:load, damit der Theme-Editor funktioniert.
   ============================================================ */
(function () {
  'use strict';

  var money = function (cents) {
    try {
      return new Intl.NumberFormat('de-DE', {
        style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'EUR'
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  };

  function bound(el, key) {
    if (el.dataset['vel' + key]) return true;
    el.dataset['vel' + key] = '1';
    return false;
  }

  /* ---------- Cart-Drawer ---------- */
  function drawer() { return document.querySelector('[data-vel-cart-drawer]'); }

  function renderCart(cart) {
    var d = drawer();
    if (!d) return;
    var list = d.querySelector('[data-vel-cart-items]');
    var totalEl = d.querySelector('[data-vel-cart-total]');
    var countEls = document.querySelectorAll('[data-vel-cart-count]');
    countEls.forEach(function (c) { c.textContent = cart.item_count; });
    if (totalEl) totalEl.textContent = money(cart.total_price);
    if (!list) return;
    if (!cart.items.length) {
      list.innerHTML = '<p class="vel-cart-empty">Dein Warenkorb ist noch leer.</p>';
      return;
    }
    list.innerHTML = cart.items.map(function (i) {
      var img = i.image
        ? '<img src="' + i.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="" width="80" height="80" loading="lazy">'
        : '<span class="vel-image-placeholder vel-image-placeholder--mini" aria-hidden="true"></span>';
      return '<div class="vel-cart-item" data-vel-line="' + i.key + '">' +
        '<div class="vel-cart-item__media">' + img + '</div>' +
        '<div class="vel-cart-item__body">' +
          '<a class="vel-cart-item__title" href="' + i.url + '">' + i.product_title + '</a>' +
          (i.variant_title && i.variant_title !== 'Default Title'
            ? '<span class="vel-cart-item__variant">' + i.variant_title + '</span>' : '') +
          '<div class="vel-cart-item__foot">' +
            '<div class="vel-cart-qty">' +
              '<button type="button" data-vel-line-step="-1" aria-label="Menge verringern">−</button>' +
              '<span>' + i.quantity + '</span>' +
              '<button type="button" data-vel-line-step="1" aria-label="Menge erhöhen">+</button>' +
            '</div>' +
            '<span class="vel-cart-item__price">' + money(i.final_line_price) + '</span>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');
  }

  function fetchCart() {
    return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { 'Accept': 'application/json' }
    }).then(function (r) { return r.json(); }).then(function (cart) {
      renderCart(cart);
      return cart;
    });
  }

  function openDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('vel-no-scroll');
  }

  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('vel-no-scroll');
  }

  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function init(root) {
    root = root || document;

    /* ---------- mobile Nav ----------
       Klassen-Toggle statt Inline-Styles: so bleibt die
       Media-Query-Kaskade intakt (siehe vel-base.css). */
    root.querySelectorAll('.vel-burger').forEach(function (burger) {
      if (bound(burger, 'Burger')) return;
      var header = burger.closest('.vel-header') || document;
      var links = header.querySelector('.vel-navlinks');
      if (!links) return;
      burger.setAttribute('aria-expanded', 'false');
      burger.addEventListener('click', function () {
        var open = links.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    /* ---------- Scroll-Reveal ---------- */
    var reveal = root.querySelectorAll('.vel-reveal:not(.is-visible)');
    if (reveal.length) {
      if (!('IntersectionObserver' in window)) {
        reveal.forEach(function (el) { el.classList.add('is-visible'); });
      } else {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
          });
        }, { rootMargin: '0px 0px -10% 0px' });
        reveal.forEach(function (el) { io.observe(el); });
      }
    }

    /* ---------- Collection: Filter + Sort ----------
       Die Pills aus der Quelle steuern jetzt echte Shopify-Parameter. */
    root.querySelectorAll('[data-vel-filter]').forEach(function (btn) {
      if (bound(btn, 'Filter')) return;
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-vel-filter');
        if (url) window.location.href = url;
      });
    });
    root.querySelectorAll('[data-vel-sort]').forEach(function (sel) {
      if (bound(sel, 'Sort')) return;
      sel.addEventListener('change', function () {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', sel.value);
        u.searchParams.delete('page');
        window.location.href = u.toString();
      });
    });

    /* ---------- Produktgalerie ---------- */
    root.querySelectorAll('[data-vel-gallery]').forEach(function (g) {
      if (bound(g, 'Gallery')) return;
      var main = g.querySelector('[data-vel-gallery-main]');
      var thumbs = g.querySelectorAll('.vel-gallery-thumb');
      if (!main || !thumbs.length) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          thumbs.forEach(function (t) { t.classList.remove('active'); });
          thumb.classList.add('active');
          var src = thumb.getAttribute('data-src');
          var srcset = thumb.getAttribute('data-srcset');
          if (!src) return;
          main.style.opacity = '0';
          setTimeout(function () {
            main.src = src;
            if (srcset) main.srcset = srcset;
            main.style.opacity = '1';
          }, 200);
        });
      });
    });

    /* ---------- Varianten-Picker ---------- */
    root.querySelectorAll('[data-vel-product-form]').forEach(function (form) {
      if (bound(form, 'Variants')) return;
      var data = form.querySelector('[data-vel-variants]');
      if (!data) return;
      var variants;
      try { variants = JSON.parse(data.textContent); } catch (e) { return; }
      var idInput = form.querySelector('[name="id"]');
      var priceEl = form.querySelector('[data-vel-price]');
      var compareEl = form.querySelector('[data-vel-compare]');
      var submit = form.querySelector('[data-vel-add]');

      function currentOptions() {
        return Array.prototype.map.call(
          form.querySelectorAll('.vel-variant-row'),
          function (row) {
            var active = row.querySelector('.active[data-vel-value]');
            return active ? active.getAttribute('data-vel-value') : null;
          }
        );
      }

      function update() {
        var opts = currentOptions();
        var match = variants.find(function (v) {
          return opts.every(function (o, i) { return o === null || v.options[i] === o; });
        });
        if (!match) return;
        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = money(match.price);
        if (compareEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            compareEl.textContent = money(match.compare_at_price);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
        if (submit) {
          submit.disabled = !match.available;
          var label = submit.querySelector('[data-vel-add-label]');
          if (label) label.textContent = match.available ? submit.getAttribute('data-label') : 'Ausverkauft';
        }
        if (match.featured_image && match.featured_image.src) {
          var main = form.closest('.vel-pdp') && form.closest('.vel-pdp').querySelector('[data-vel-gallery-main]');
          if (main) main.src = match.featured_image.src;
        }
      }

      form.querySelectorAll('.vel-variant-row').forEach(function (row) {
        row.querySelectorAll('[data-vel-value]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            row.querySelectorAll('[data-vel-value]').forEach(function (b) { b.classList.remove('active'); });
            btn.classList.add('active');
            update();
          });
        });
      });
      update();
    });

    /* ---------- Mengen-Stepper ---------- */
    root.querySelectorAll('.vel-qty').forEach(function (wrap) {
      if (bound(wrap, 'Qty')) return;
      var input = wrap.querySelector('input');
      if (!input) return;
      wrap.querySelectorAll('button[data-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-step'), 10) || 0;
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    /* ---------- AJAX Add-to-Cart ---------- */
    root.querySelectorAll('[data-vel-product-form]').forEach(function (form) {
      if (bound(form, 'Add')) return;
      form.addEventListener('submit', function (e) {
        if (!drawer()) return;           // ohne Drawer normaler POST
        e.preventDefault();
        var btn = form.querySelector('[data-vel-add]');
        if (btn) btn.classList.add('is-loading');
        fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
          .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.body.description || 'Fehler');
            return fetchCart();
          })
          .then(function () { openDrawer(); })
          .catch(function (err) {
            var box = form.querySelector('[data-vel-form-error]');
            if (box) { box.textContent = err.message; box.hidden = false; }
          })
          .finally(function () { if (btn) btn.classList.remove('is-loading'); });
      });
    });

    /* ---------- Drawer-Steuerung ---------- */
    root.querySelectorAll('[data-vel-cart-open]').forEach(function (btn) {
      if (bound(btn, 'CartOpen')) return;
      btn.addEventListener('click', function (e) { e.preventDefault(); fetchCart().then(openDrawer); });
    });
    var d = drawer();
    if (d && !bound(d, 'Drawer')) {
      d.addEventListener('click', function (e) {
        if (e.target.hasAttribute('data-vel-cart-close') || e.target === d) return closeDrawer();
        var step = e.target.getAttribute('data-vel-line-step');
        if (step) {
          var line = e.target.closest('[data-vel-line]');
          var qtyEl = line && line.querySelector('.vel-cart-qty span');
          if (!line || !qtyEl) return;
          var next = Math.max(0, (parseInt(qtyEl.textContent, 10) || 1) + parseInt(step, 10));
          changeLine(line.getAttribute('data-vel-line'), next);
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeDrawer();
      });
      fetchCart();
    }

    /* ---------- Related Products ---------- */
    root.querySelectorAll('[data-vel-recommendations]').forEach(function (box) {
      if (bound(box, 'Reco')) return;
      var pid = box.getAttribute('data-product-id');
      var limit = box.getAttribute('data-limit') || 4;
      if (!pid) return;
      fetch('/recommendations/products?section_id=' + box.getAttribute('data-section-id') +
            '&product_id=' + pid + '&limit=' + limit)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var inner = parsed.querySelector('[data-vel-recommendations]');
          if (inner && inner.innerHTML.trim()) {
            box.innerHTML = inner.innerHTML;
            init(box);
          } else {
            box.closest('.vel-related') && box.closest('.vel-related').setAttribute('hidden', '');
          }
        })
        .catch(function () { /* still: Section bleibt leer */ });
    });
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState !== 'loading') init(document);
})();
